export default "__VITE_ASSET__BdSi7kj1__"